import React, { Component } from "react";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import ModalsVentasPage from "./modals.ventas.page";
import Select from 'react-select'
import moment from 'moment'
import HeaderVentas from "../../components/header.ventas";

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };

class AltasModulePage extends Component {
	constructor(props) {
    super(props);
    this.keyBindingBtns = this.keyBindingBtns.bind(this);
    this._handleKeyDown = this._handleKeyDown.bind(this)

    this.state = {
      mostrarMisVentas: false,
      arrStock: [],
      dateAlmacen: moment().format('YYYY-MM-DD'),

      valSearch: '',
      valSearchByFullCode: '',
      indexItemByKeyboard: -1,
      isOpenSearchProducto: false,
		}
	}

  componentDidMount() {
    this.getStockAlmacen()
    document.addEventListener("keydown", this.keyBindingBtns, false);
	}

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyBindingBtns, false);
  }

  keyBindingBtns(event) {
    const { indexItemByKeyboard, arrayListResults, isOpenSearchProducto, isOpenPagarCompra, } = this.props.subState
    const { renderView } = this.props.initState

    if(renderView !== 'altas')
      return false
    // [productos] F2  -> 113
    // [abajo]     ⬇  -> 40
    // [arriba]    ⬆  -> 38
    // [enter]     ⤵  -> 13

    if(event.keyCode === 113) {

      this.setBindProductos()
    } else if(event.keyCode === 40) {

      if(isOpenSearchProducto)
        this.props.subSetState({ indexItemByKeyboard: indexItemByKeyboard < (arrayListResults.length - 1) ? (indexItemByKeyboard + 1) : indexItemByKeyboard })
    } else if(event.keyCode === 38) {

      if(isOpenSearchProducto)
        this.props.subSetState({ indexItemByKeyboard: indexItemByKeyboard > 0 ? (indexItemByKeyboard - 1) : indexItemByKeyboard })
    } else if(event.keyCode === 13) {
      
      if(isOpenSearchProducto && arrayListResults.length > 0) {
        this.selectItemProduct(indexItemByKeyboard)
        this.props.subSetState({ indexItemByKeyboard: 0, })
      } else if(isOpenPagarCompra) {
        // this.onRegisterNewVenta()
      }
    } else if(event.keyCode === 9) {
      if( document.activeElement.id === 'ws-input-search-code' ) {
        this.onSearchProductoByCode()
        event.preventDefault()
      }
    }
  }


	render() {
    const { mostrarMisVentas } = this.state

		let { arrListVenta } = this.props.subState
    let cantidadTotal = 0
    arrListVenta.map((t) => { cantidadTotal += ( t.precio * t.cantidad )})

    return (
    	<div style={{ padding: 0, background: '#fff', margin: 0, }}>
        <HeaderVentas initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) } />

    		<p
    			className={'altasModule__btnAction'}
    			onClick={() =>{ this.props.subSetState({ isOpenAltaProductos: true, }) }}
    		>Registrar nuevo producto</p>
    		<p
    			className={'altasModule__btnAction'}
    			onClick={() =>{ this.setState({ mostrarMisVentas: !mostrarMisVentas }) }}
    		>{mostrarMisVentas ? 'Ver mi almacen' : 'Registrar entrada al almacen'}</p>
    		
    		{ this.state.mostrarMisVentas ? this.makeViewAlmacen() : this.makeViewVentas() }
				
				<ModalsVentasPage
					subState={ this.props.subState } subSetState={ (param) => this.props.subSetState(param) }
					initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) }
          selectItemProduct={ (e) => this.selectItemProduct(e) }
				/>
			</div>
		)
  }

  makeViewAlmacen() {
  	const { fecha_entrada_almacen, serie_almacen, referencia_almacen, noDocEntradaAlmacen, } = this.props.subState

  	return (
  		<div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
        {/* Principal Container */}
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col className={'z-depth-1'} style={{ background: '#fff', }}>
            
        		<Row>
        			<p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'center', width: '100%', }}>Entrada al almacen</p>
        			<hr />
        		</Row>

            <Row>
            	<Col>
            		<Row>
            			<Col>
            				<p className="regVentaPage__product" style={{ padding: 0, }}>Fecha</p>
            			</Col>
		            	<Col xs={'7'}>
               			<input type={"date"}
               				value={fecha_entrada_almacen}
               				onChange={(event) => {this.props.subSetState({fecha_entrada_almacen: event.target.value}) }}
               				style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
               			/>
		            	</Col>
            		</Row>

            		<Row>
            			<p className="regVentaPage__product" style={{ padding: '0 15px', width: '100%', }}>Documento #{noDocEntradaAlmacen}</p>
            		</Row>
            	</Col>

            	<Col>
            		<Row>
            			<Col>
            				<p className="regVentaPage__product" style={{ padding: 0, }}>Serie</p>
            			</Col>
            			<Col xs={'7'}>
            				<input type={'text'}
            					placeholder={'Ingresa una serie'}
            					value={serie_almacen}
            					onChange={ (event) => { this.props.subSetState({serie_almacen: event.target.value}) }}
            					style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
            				/>
            			</Col>
            		</Row>
            		<Row>
            			<Col>
            				<p className="regVentaPage__product" style={{ padding: 0, }}>Referencia</p>
            			</Col>
            			<Col xs={'7'}>
            				<input type={'text'}
            					placeholder={'Ingresa una referencia'}
            					value={referencia_almacen}
            					onChange={ (event) => { this.props.subSetState({referencia_almacen: event.target.value}) }}
            					style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
            				/>
            			</Col>
            		</Row>
            	</Col>
            </Row>

            <hr />

            <Row>
              <Col xs={'2'}>
                <b>Código</b>
              </Col>
              <Col xs={'3'}>
                <b>Nombre</b>
              </Col>
              <Col xs={'2'}>
                <b>Cantidad</b>
              </Col>
              <Col xs={'2'}>
                <b>Costo</b>
              </Col>
              <Col xs={'2'}>
                <b>Total</b>
              </Col>
              <Col xs={'1'}>
                <b>Opciones</b>
              </Col>
            </Row>

            <hr />

            { this.makeItemsEntradasAlmacen() }

          </Col>

        </Row>

      </div>

  	)
  }

  makeViewVentas() {
    const { fecha_entrada_almacen, serie_almacen, referencia_almacen, noDocEntradaAlmacen, } = this.props.subState

    return (
      <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
        {/* Principal Container */}
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col className={'z-depth-1'} style={{ background: '#fff', }}>
            
            <Row>
              <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'center', width: '100%', }}>Mi almacen</p>
              <hr />
            </Row>

            <hr />

            <input
              type={'date'}
              value={ this.state.dateAlmacen }
              onChange={(e) => { this.setState({ dateAlmacen: e.target.value }) }}
            />
            <br />
            <p className={'btn btn-primary'} onClick={() => { this.getStockAlmacen() }}>Generar</p>

            <hr />

            {
              this.state.arrStock.map((t,e) => (
                <>
                {
                  t.list.length > 0 ? (
                    <>
                      <p>{t.nombre}</p>

                      <Row>
                        <Col xs={'4'}>
                          <b>Nombre</b>
                        </Col>
                        <Col xs={'2'}>
                          <b>Existencia</b>
                        </Col>
                        <Col xs={'2'}>
                          <b>Entrada del día</b>
                        </Col>
                        <Col xs={'1'}>
                          <b>Merma</b>
                        </Col>
                        <Col xs={'1'}>
                          <b>Traspaso</b>
                        </Col>
                        <Col xs={'2'}>
                          <b>Vendida</b>
                        </Col>
                      </Row>

                      {
                        t.list.map((t0,e0) => (
                          <Row style={{ marginTop: 20, marginBottom: 20, }}>
                            <Col xs={'4'}>
                              <p>{t0.nombre}</p>
                              <p>{t0.clave}</p>
                            </Col>
                            <Col xs={'2'}>
                              <p>{(t0.disponible)}</p>
                            </Col>
                            <Col xs={'2'}>
                              <p>{(t0.cantidad_dia)}</p>
                            </Col>
                            <Col xs={'1'}>
                              <p>{t0.cantidad_merma}</p>
                            </Col>
                            <Col xs={'1'}>
                              <p>{t0.cantidad_traspaso}</p>
                            </Col>
                            <Col xs={'2'}>
                              <p>{t0.cantidad_vendida}</p>
                            </Col>
                          </Row>
                        ))
                      }

                    </>
                  ) : null
                }
                </>
              ))
            }

          </Col>

        </Row>

      </div>

    )
  }

  makeItemsEntradasAlmacen() {
  	const { arrItemsAlmacen, arrayListProductos, } = this.props.subState
    let cantidadTotal = 0
    arrItemsAlmacen.map((t) => { cantidadTotal += ( t.costo * t.cantidad )})

  	//Show item new
  	return (

  		<>
  			{
  				arrItemsAlmacen.map((t,e) => (
  					<Row>
              <Col xs={'2'}>
                <b>{t.codigo}</b>
              </Col>
              <Col xs={'3'}>
                <b>{t.producto}</b>
              </Col>
              <Col xs={'2'}>
                <input
	                ref={input => {
	                	this[`inputAlmacenNew${e}`] = input;
	                }}
                	type={'text'}
                	onChange={ (event) => {
                		arrItemsAlmacen[e].cantidad = event.target.value;
                		this.props.subSetState({ arrItemsAlmacen });
                	}}
                	value={ t.cantidad }
                	placeholder={'Ingresa la cantidad'}
                	style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                />
              </Col>
              <Col xs={'2'}>
                <input type={'text'}
                	onChange={ (event) => {
                		arrItemsAlmacen[e].costo = event.target.value;
                		this.props.subSetState({ arrItemsAlmacen });
                	}}
                	value={ t.costo }
                	placeholder={'Ingresa el costo'}
                	style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                />
              </Col>
              <Col xs={'2'}>
                <p> ${ this.number_format((t.cantidad * t.costo), 2) } </p>
              </Col>
              <Col xs={'1'}>
                <p
                	style={{ cursor: 'pointer', color: 'red', fontWeight: '800', }}
                	onClick={() => {
                		const arr = arrItemsAlmacen.filter(function(item, index) { return index !== e })
                		this.props.subSetState({ arrItemsAlmacen: arr })
                	}}
                >X</p>
              </Col>
            </Row>
  				))
  			}

  			{
  				arrItemsAlmacen.length > 0
  				? (
  					<div>
              <p style={{ textAlign: 'right', }}>Total: ${this.number_format(cantidadTotal, 2)}</p>

	            <p
	            	className={'modalsVentas__btnAddProducto'}
	            	onClick={() => { this.onRegisterEntradaAlmacen() }}
	            >Registrar entrada</p>
	          </div>
  				) : null
  			}

  			<hr />

        {
          arrayListProductos.length > 0 ? (
    			  <Row style={{ marginTop: 20, }}>
              <Col xs={'4'} style={{ cursor: 'pointer', }}
                onClick={ () => { this.setBindProductos() }}
                >
                <p>Elige un producto para agregar a la lista</p>
              </Col>
              <Col xs={'6'}>
                <input
                  type="text"
                  id={'ws-input-search-code'}
                  autoComplete="off"
                  placeholder="Ingresa el código del producto..."
                  value={this.state.valSearchByFullCode}
                  onChange={(e) => { this.setState({ valSearchByFullCode: e.target.value }) } }
                  onKeyDown={this._handleKeyDown}
                  ref={(input) => { this.inputSearchByCode = input;  }}
                  style={{ margin: '20px auto', marginTop: 0, width: '100%', background: '#f3f3f3', border: '1px solid #ccc', borderRadius: 4, }}
                />
              </Col>
            </Row>
          ) : null
        }

  		</>
  	)
  }

  _handleKeyDown(e) {
    if(e.key === 'Enter') {
      this.onSearchProductoByCode()
    }
  }

  onSearchProductoByCode() {
    let { valSearchByFullCode, } = this.state
    let { arrListVenta, arrayListProductos, arrItemsAlmacen, } = this.props.subState

    if(valSearchByFullCode.trim() == '')
      return false

    let countLimit = 0
    let index = -1

    for(var a in arrayListProductos) {
      if(arrayListProductos[a].folio == valSearchByFullCode) {
        index = a
        break;
      }
    }

    if(index > -1) {
      let codigo = '', producto = ''
      let t = arrayListProductos[index]

      if( t.nombre.indexOf(' - ') !== -1) {
        //Tiene código (separar)
        const sep = t.nombre.split(' - ')
        codigo = sep[0]
        producto = sep[1]
      } else
        producto = t.nombre;

      let newItem = [{
        id_producto: t.id_producto,
        codigo,
        producto,
        cantidad: '',
        costo: '',
      }]

      arrItemsAlmacen = [ ...arrItemsAlmacen, ...newItem ]

      this.props.subSetState({ arrItemsAlmacen, })
      this.setState({valSearchByFullCode: '',})

      setTimeout(() => {
        const index0 = arrItemsAlmacen.length - 1
        this[`inputAlmacenNew${(index0)}`].focus();
      }, 100)
    }

  }

  selectItemProduct(e) {
    let { arrItemsAlmacen, arrayListResults } = this.props.subState
    const t = arrayListResults[e]
    let codigo = '', producto = ''

    if( t.nombre.indexOf(' - ') !== -1) {
      //Tiene código (separar)
      const sep = t.nombre.split(' - ')
      codigo = sep[0]
      producto = sep[1]
    } else
      producto = t.nombre;

    let newItem = [{
      id_producto: t.id_producto,
      codigo,
      producto,
      cantidad: '',
      costo: '',
    }]

    arrItemsAlmacen = [ ...arrItemsAlmacen, ...newItem ]

    this.props.subSetState({
      arrItemsAlmacen,
      isOpenSearchProducto: false,
      valSearch: '',
    })

    setTimeout(() => {
      const index = arrItemsAlmacen.length - 1
      // this[`inputVentaID${(index)}`].focus();
    }, 100)

  }

  setBindProductos() {
    this.props.subSetState({ isOpenSearchProducto: true })
  }

  onRegisterEntradaAlmacen() {
  	const { id_vendedor, id_sucursal, } = this.props.initState
  	const { arrItemsAlmacen, fecha_entrada_almacen, serie_almacen, referencia_almacen, } = this.props.subState
    const { mostrarMisVentas } = this.state

  	//Validamos que todos los items ya tengan cantidad y costo
  	let flag = true
  	for(var a in arrItemsAlmacen) {
  		if(arrItemsAlmacen[a].cantidad == '' || arrItemsAlmacen[a].costo == '') {
  			flag = false;
  		}

  		if( a == (arrItemsAlmacen.length - 1) ) {
  			
  			//Registramos la entrada en la BD
  			if(!flag || serie_almacen == '' || referencia_almacen == '' ) {
  				alert('Por favor, registra la cantidad y el costo de cada producto.')
  				return false
  			} else {
  				const data = {
  					id_vendedor,
  					id_sucursal,
  					arrItemsAlmacen,
  					fecha_entrada_almacen,
  					serie_almacen,
  					referencia_almacen,
  				}
  				fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setRegisterEntradaAlmacen", this.headersPOST({...data}))
  				.then(response => response.json())
  				.then((response) => {
  					this.props.subSetState({
  						noDocEntradaAlmacen: response.noDocEntradaAlmacen,
  						arrItemsAlmacen: [],
  						fecha_entrada_almacen: moment().format('YYYY-MM-DD'),
  						serie_almacen: '',
  						referencia_almacen: '',
  					})

  					alert('¡Entrada registrada con éxito!')
            this.setState({ mostrarMisVentas: !mostrarMisVentas, })

            this.getStockAlmacen()

  				}).catch((error) => console.info(error));

  			}
  		}
  	}
  	return false
  }

  getStockAlmacen() {
    const { dateAlmacen } = this.state
    const { id_sucursal } = this.props.initState
    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getStockAlmacen", this.headersPOST({ id_sucursal, dateAlmacen }))
    .then(response => response.json())
    .then((response) => {
      this.setState({arrStock: response})
      // console.log(response)
    })
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  number_format(number, decimals, decPoint, thousandsSep) {
  	number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
  	var n = !isFinite(+number) ? 0 : +number
  	var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  	var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  	var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  	var s = ''
  	var toFixedFix = function (n, prec) {
  		var k = Math.pow(10, prec)
  		return ''+(Math.round(n * k) / k)
  		.toFixed(prec)
  	}
  	s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
  	if (s[0].length > 3) {
  		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  	}
  	if ((s[1] || '').length < prec) {
  		s[1] = s[1] || ''
  		s[1] += new Array(prec - s[1].length+1).join('0')
  	}
  	return s.join(dec)
  }


}

export default withRouter(AltasModulePage)





